export enum CreationMethod {
  Manual = 'M',
  Automatic = 'A'
}
